module.exports = __webpack_public_path__ + "img/gpt-addin-01.b89cc1ad.png";